import React from "react";
import { createForm, type Form, type IFormProps } from "@formily/core";

export const useFormily = <T extends object>(options: IFormProps<T>) => {
  // useRef(createForm(options)) would build a throwaway form on every render.
  const formilyRef = React.useRef<Form<T> | null>(null);
  formilyRef.current ??= createForm(options);
  return formilyRef.current;
};
